module.exports = __webpack_public_path__ + "img/x-logo.ef9724af.png";